import AgentResultListView from 'views/agents/agentResultListView'
var TrashBinListView = AgentResultListView.extend({
});

export default TrashBinListView;

